import { Component, computed, input, output, signal, ViewEncapsulation } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25IconComponent } from "../../modules/s25-icon/s25.icon.component";
import { S25Icons } from "../../modules/s25-icon/s25.icon.const";
import { FavoriteItem, FavoriteService } from "../../services/favorite.service";

@TypeManagerDecorator("s25-ng-favorite-button")
@Component({
    selector: "s25-ng-favorite-button",
    template: `
        <s25-ng-icon
            aria-hidden="true"
            class="favorite-button__star-icon"
            [class.favorite-button__star-icon--off]="!isFavorite()"
            [class.favorite-button__star-icon--on]="isFavorite()"
            [autoDarkMode]="true"
            [label]="message()"
            [type]="isFavorite() ? Icons.starOn : Icons.starOff"
        ></s25-ng-icon>
    `,
    host: {
        role: "button",
        tabindex: "0",
        "[class.favorite-button]": "true",
        "[class.favorite-button--pending]": "pending() !== undefined",
        "[attr.aria-label]": "message()",
        "(click)": "toggle()",
        "(keyup.enter)": "toggle()",
        "(keyup.space)": "toggle()",
        "(keydown.space)": "$event.preventDefault()",
    },
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ["./s25.favorite.button.component.scss"],
    standalone: true,
    imports: [S25IconComponent],
})
export class S25FavoriteButtonComponent {
    public readonly item = input.required<FavoriteItem>();
    public readonly favoriteChange = output<boolean>();

    public readonly isFavorite = computed(() => this.pending() ?? FavoriteItem.isStarred(this.item()));
    public readonly message = computed(() => {
        if (this.pending() !== undefined) {
            return this.pending() ? "Adding to Favorites..." : "Removing from Favorites...";
        } else {
            return this.isFavorite() ? "Remove from Favorites" : "Add to Favorites";
        }
    });
    public readonly pending = signal<boolean | undefined>(undefined);

    protected readonly Icons = S25Icons.names;

    public toggle() {
        if (this.pending() === undefined) {
            const newValue = !this.isFavorite();
            this.pending.set(newValue);
            void FavoriteService.toggle(this.item())
                .then(() => this.favoriteChange.emit(newValue))
                .finally(() => this.pending.set(undefined));
        }
    }
}
